<template>
<div>
    <cBookingStatus :bookingStatus="page"></cBookingStatus>
</div>
</template>

<script>
    import {mapGetters, mapActions} from "vuex";
    import cBookingStatus from "../../../../components/confirmation/cBookingStatus";
    import { COMPONENT_NAME,PATHNAME,} from "../../../../util/constants";
import { addClassToBody,removeClassBody } from "../../../../util/util";
export default {
    components: {
    cBookingStatus
  },
   data: () => ({
            page: 'PendingPage',
            
        }), 
    

        mounted() {
           //this.$root.$emit("toggle-fixed-header", true);
           this.$root.$emit("toggle-sidebar-minimize");
        },

        created(){
            this.$root.$emit("toggle-sidebar-minimize"); 
        },
        beforeCreate() {    
   addClassToBody(COMPONENT_NAME.PENDINGPAGE);
  },
  
   beforeDestroy() {
                this.$root.$emit("toggle-sidebar-minimize", true);

       removeClassBody();
    },
}
</script>


